module.exports = __webpack_public_path__ + "img/logo_6.f5a4b4c1.png";